import React from 'react';
import { ContentWrapperBlocks } from '../ContentWrapper.types';
import { BlockBar } from '../../../../_lib/components/BlockBar';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type ContentWrapperDragPreview = {
  position: number;
  block: ContentWrapperBlocks;
};

/**
 * Preview of the dragged ContentWrapper Block.
 * Using the BlockBar as it looks the same as the BlockInteractions bar.
 */
export function ContentWrapperDragPreview({ block, position }: ContentWrapperDragPreview) {
  const { t } = useSonTranslation('ContentWrapper');

  const blockName = t(`glossary:contentBlocks.${block.elementType}`);
  const positionName = ` (${t(`position`)} ${position})`;

  return <BlockBar heading={blockName} position={positionName} hierarchy={2} />;
}
